/* eslint-env browser */
const lightWorker = new Worker('scripts/worker-light.js')

const isSingleFoto = document.querySelector('.single')
const lightContainer = document.querySelector('.light-container')
const lightBox = document.querySelector('.lightbox')

let card
let initWorker
let endSizes
let rectLight

let light
let lightCard

const getRectLight = () => {
  fastdom.measure(() => { // eslint-disable-line no-undef
    rectLight = lightContainer.getBoundingClientRect()
  })
}

getRectLight()

const killLight = () => {
  fastdom.mutate(() => {
    if (card) card.classList.remove('--invisible-block')
    lightBox.classList.remove('--ativo')
    if (endSizes && !endSizes.wIsLandscape) lightBox.classList.remove('--black')
    if (light) {
      noScroll()
      light.remove()
      light = null
    }
  })
}

const closeLight = () => {
  fastdom.mutate(() => {
    light.classList.remove('--ativo')
    lightBox.classList.remove('--ativo')
    light.style.top = `${initWorker.y}px`
    light.style.left = `${initWorker.x}px`
    lightCard.style.height = `${initWorker.height}px`
    lightCard.style.width = `${initWorker.width}px`
    light.addEventListener('transitionend', () => setTimeout(killLight, 100), false)
  })
}
const openLight = (e = window.event) => {
  e.preventDefault()

  const {
    target,
  } = e

  card = target.parentNode.parentNode
  fastdom.measure(() => { // eslint-disable-line no-undef
    const cardRect = card.getBoundingClientRect()
    initWorker = {
      y: cardRect.y,
      x: cardRect.x,
      height: cardRect.height - 15,
      width: cardRect.width - 15,
      wheight: rectLight.height,
      wwidth: rectLight.width,
    }
    light = card.cloneNode(true)
    light.classList.add('light')


    lightCard = light.querySelector('.foto-click > img')
    lightCard.style.height = `${initWorker.height}px`
    lightCard.style.width = `${initWorker.width}px`

    light.querySelector('.foto-click').removeAttribute('href')
    light.querySelector('.foto-click').removeAttribute('onclick')
    lightWorker.postMessage(initWorker)
    lightWorker.onmessage = data => {
      endSizes = data.data
      initWorker.y = endSizes.wIsLandscape ? initWorker.y : initWorker.y + 7.5
      initWorker.x = endSizes.wIsLandscape ? initWorker.x : initWorker.x + 7.5
      light.style.top = `${initWorker.y}px`
      light.style.left = `${initWorker.x}px`
      fastdom.mutate(() => { // eslint-disable-line no-undef
        if (!endSizes.isLandscape && endSizes.portraitPosible) light.classList.add('--portrait')
        else if (!endSizes.isLandscape) light.classList.add('--w-portrait')
        if (!endSizes.wIsLandscape) light.classList.add('--w-portrait')
        if (endSizes.orientationIsIgual) light.classList.add('--i-orientation')
        lightContainer.appendChild(light)
        card.classList.add('--invisible-block')
        fastdom.measure(() => { // eslint-disable-line no-undef
          fastdom.mutate(() => { // eslint-disable-line no-undef

            if (!endSizes.wIsLandscape || (!endSizes.isLandscape && !endSizes.portraitPosible)) {
              lightBox.classList.add('--black')
              light.querySelector('.head').addEventListener('transitionend', () => {
                light.classList.add('--fix-exit')
              }, false)
            } else {
              lightBox.classList.remove('--black')
            }
            lightBox.classList.add('--ativo')

            noScroll() // eslint-disable-line no-undef

            light.classList.add('--ativo')

            fastdom.measure(() => { // eslint-disable-line no-undef
              fastdom.mutate(() => { // eslint-disable-line no-undef
                light.style.top = `${endSizes.y}px`
                light.style.left = `${endSizes.x}px`
                lightCard.style.height = `${endSizes.height}px`
                lightCard.style.width = `${endSizes.width}px`
              })
            })
          })
        })
      })
    }
  })
}


if (!isSingleFoto) {
  window.addEventListener('resize', getRectLight, false)
  window.addEventListener('resize', killLight, false)
}
